import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { Table } from "antd";
import apiHelpers from "./data";
import FullPageLoader from "../common/FullPageLoader";
import ErrorNotification from "../common/ErrorNotification";
import columns from "./columns";

const AuditTable = () => {
    const [data, setData] = useState([]);
    const [isloader, setisloader] = useState(true);
    const tableWrapperRef = useRef(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [stickyHeader, setStickyHeader] = useState(false);

    const fetchData = async () => {
        const response = await apiHelpers.apidata();
        setData(response);
        setisloader(false);
    };
    useEffect(() => {
        fetchData();
    }, []);
    const updatedColumns = useMemo(() => {
        return columns
            .filter((col) => col.dataIndex)
            .map((col) => {

                return col;
            });
    });
    return (
        <>
            <div style={{ marginBottom: 16 }} className="TableFilterBox"></div>
            <div
                className="TableBox"
                ref={tableWrapperRef}
                style={{ maxHeight: 700, overflow: 'auto' }}
            >
                <Table                   
                    columns={updatedColumns}
                    dataSource={data}
                    pagination={{
                        current: currentPage,
                        pageSize: pageSize,
                        total: data.length,
                        onChange: (page, pageSize) => {
                            setCurrentPage(page);
                            setPageSize(pageSize);
                        },
                        showSizeChanger: true,
                        pageSizeOptions: ['10', '20', '50', '100'],
                        position: ['bottomLeft'],
                    }}
                    bordered
                    scroll={{ x: '100%', y: 500 }}
                    sticky={stickyHeader ? { offsetHeader: 0 } : false}
                />

                <FullPageLoader isloader={isloader} />
                <ErrorNotification {...alert} />
            </div>
        </>
    )
}
export default AuditTable;